//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateMapeoGastos } from "@/typings/store/plugins/easyFirestore/mapeoGastos";

const getters: GetterTree<StateMapeoGastos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const mapeoGastos = {
    firestorePath: "dev/v1/mapeoGastos",
    firestoreRefType: "collection",
    moduleName: "mapeoGastos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default mapeoGastos;
